module.exports = __webpack_public_path__ + "static/media/iconClose.350f76ed.svg";